import { type ChartType } from '#src/types';
import { type MachineContextType } from './types';

export function checkComparison(
  context: MachineContextType,
  check: 'some' | 'all' = 'all'
): boolean {
  const compareByLength = context.compareBy.length;

  if (check === 'some') {
    // at least one dimension should be compared
    return compareByLength === 1;
  }

  // max dimensions (2) should be compared
  return compareByLength === 2;
}

export function hasThreeDimensions(context: MachineContextType) {
  return (
    (context.yearsMode !== 'single' ||
      (context.viewType === 'table' && context.data.isMonthly)) &&
    checkComparison(context)
  );
}

export function hasTwoDimensions(
  context: MachineContextType,
  chartType: ChartType
) {
  return (
    checkComparison(context) ||
    (checkComparison(context, 'some') &&
      (context.yearsMode !== 'single' ||
        // we need to check for area and earmarking because they are special cases
        // area renders monthly data so it needs to be forced to be a comparison
        // earmarking renders a mark per type of earmarking so it needs to be forced to be a comparison
        // so they need to be forced to be a comparison
        (context.viewType === 'chart' &&
          (chartType === 'area' || context.category === 'EMK')) ||
        (context.viewType === 'table' && context.data.isMonthly)))
  );
}

export function isBarChart(context: MachineContextType) {
  return context.chartType === 'bar';
}

export function isLineChart(context: MachineContextType) {
  return context.yearsMode === 'range' && context.chartType === 'line';
}

export function isAreaChart(context: MachineContextType) {
  return context.chartType === 'area';
}
